import { __assign } from "tslib";
import { HubSdkTelemetryService } from './telemetry-service';
var WebContentSdkService = /** @class */ (function () {
    function WebContentSdkService(
    // TODO: Resolve inability to access global window through IWindowProvider https://domoreexp.visualstudio.com/MSTeams/_workitems/edit/746287
    hostWindow, context, authenticationService, logger, customTelemetryService, onAppInitStateChanged) {
        var _this = this;
        this.hostWindow = hostWindow;
        this.context = context;
        this.authenticationService = authenticationService;
        this.logger = logger;
        this.customTelemetryService = customTelemetryService;
        this.onAppInitStateChanged = onAppInitStateChanged;
        this.initialized = false;
        /**
         * Initialize authentication context
         * @param context optional app specific context to override the base authentication context
         */
        this.initializeAuthenticationContext = function (context) {
            var _a;
            _this.context = context;
            _this.contextPromise = (_a = _this.authenticationService) === null || _a === void 0 ? void 0 : _a.getUser().then(function (user) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                // fill user info and merge other details from Context
                var userInfo = __assign(__assign({}, (_a = _this.context) === null || _a === void 0 ? void 0 : _a.user), { id: ((_b = user === null || user === void 0 ? void 0 : user.profile) === null || _b === void 0 ? void 0 : _b.oid) || '', displayName: ((_c = user === null || user === void 0 ? void 0 : user.profile) === null || _c === void 0 ? void 0 : _c.displayName) || '', loginHint: ((_d = user === null || user === void 0 ? void 0 : user.profile) === null || _d === void 0 ? void 0 : _d.loginHint) || '', userPrincipalName: ((_e = user === null || user === void 0 ? void 0 : user.profile) === null || _e === void 0 ? void 0 : _e.upn) || '', tenant: {
                        id: ((_f = user === null || user === void 0 ? void 0 : user.profile) === null || _f === void 0 ? void 0 : _f.tid) || '',
                        sku: (_j = (_h = (_g = _this.context) === null || _g === void 0 ? void 0 : _g.user) === null || _h === void 0 ? void 0 : _h.tenant) === null || _j === void 0 ? void 0 : _j.sku,
                    } });
                // fill app info and merge other details from Context
                var appInfo = __assign(__assign({}, _this.context.app), { userClickTime: _this.getUserClickTime() });
                // merge context and userInfo to form appContext
                var appContext = __assign(__assign({}, _this.context), { app: appInfo, user: userInfo });
                _this.telemetryService.setAppContext(appContext);
                return appContext;
            });
        };
        /**
         * Gets the MetaOS web context.
         * Context provided by the Hubs
         */
        this.getContext = function () {
            return _this.context;
        };
        /**
         * Gets the MetaOS app context.
         * Context provided to the Apps from AppSDK
         */
        this.getAppContext = function () {
            if (_this.contextPromise) {
                return _this.contextPromise.then(function (context) { return context; }).catch(function () { return _this.context; });
            }
            else {
                return Promise.resolve(_this.context);
            }
        };
        this.getAppDefinition = function () { return _this.appDefinition; };
        this.checkIfCachedAndRequestAllowed = function (_) { return true; };
        /**
         * updates current AppInitState value to the new one provided by caller
         *
         * @param appInitState new AppInitState to set
         */
        this.setAppInitInfo = function (appInitState) {
            if (_this.onAppInitStateChanged) {
                _this.onAppInitStateChanged(appInitState);
            }
        };
        /**
         * gets the logger from hubs
         */
        this.getLogger = function () { return _this.logger; };
        this.telemetryService = new HubSdkTelemetryService(this.getHubInfo(), context, this.customTelemetryService);
        // init the local userClickTime from Context
        if (this.context.app.userClickTime) {
            this.userClickTime = this.context.app.userClickTime;
        }
    }
    /**
     * to check if sdk service is initialized
     */
    WebContentSdkService.prototype.isInitialized = function () {
        return this.initialized;
    };
    /**
     * sets the SDK as initialized/un-initialized
     */
    WebContentSdkService.prototype.setInitialized = function (isInitialized) {
        this.initialized = isInitialized;
    };
    /**
     * gets the Hub related info from appContext
     */
    WebContentSdkService.prototype.getHubInfo = function () {
        var hubInfo = {
            name: this.context.app.host.name,
            version: this.context.app.host.version,
            clientType: this.context.app.host.clientType,
            sessionId: this.context.app.host.sessionId,
        };
        return hubInfo;
    };
    /**
     * function to execute when app frame is unloaded
     */
    WebContentSdkService.prototype.unloadApp = function (appDefinition) {
        this.telemetryService.createScenario('appTermination', appDefinition.id).stop();
    };
    /**
     * get HostWindow
     */
    WebContentSdkService.prototype.getHostWindow = function () {
        return this.hostWindow;
    };
    /**
     * get FrameContext
     */
    WebContentSdkService.prototype.getFrameContext = function () {
        return this.context.page.frameContext;
    };
    /**
     * Gets time when user clicked on the app.
     */
    WebContentSdkService.prototype.getUserClickTime = function () {
        return this.userClickTime;
    };
    /**
     * Sets time when user clicked on the app.
     */
    WebContentSdkService.prototype.setUserClickTime = function (value) {
        this.userClickTime = value;
    };
    /**
     * Starts the app Initialization scenario
     */
    WebContentSdkService.prototype.startAppInitializationScenario = function () {
        var _a;
        this.appInitializationScenario = (_a = this.telemetryService) === null || _a === void 0 ? void 0 : _a.createScenario('appInitialization', undefined, this.getUserClickTime());
    };
    /**
     * @returns appInitializationScenario
     */
    WebContentSdkService.prototype.getAppInitializationScenario = function () {
        return this.appInitializationScenario;
    };
    return WebContentSdkService;
}());
export { WebContentSdkService };
//# sourceMappingURL=web-content-sdk.js.map